import { useEffect } from "react";

export function useDebounce(value, onChange) {
  useEffect(() => {
    const timeout = setTimeout(() => onChange(value), 250);
    return () => clearTimeout(timeout);
  }, [value, onChange]);
}
